export default __webpack_public_path__ + "static/media/M15.722888a3.svg";